import { render, staticRenderFns } from "./ContratosLista.vue?vue&type=template&id=521f9f02&scoped=true"
import script from "./ContratosLista.vue?vue&type=script&lang=js"
export * from "./ContratosLista.vue?vue&type=script&lang=js"
import style0 from "./ContratosLista.vue?vue&type=style&index=0&id=521f9f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f9f02",
  null
  
)

export default component.exports